import { IonIcon, IonItem } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";
import { type Shift } from "@/lib/backend/api";
import { hourglassIcon } from "@/lib/icons/hourglass.icon";
import { Routes } from "@/lib/router";
import { ShiftApplicationDetails } from "../shift-application/shift-application-details";

type ShiftCardOverviewProps = {
  shift: Shift;
};

export function UpcomingShiftCardOverview({ shift }: ShiftCardOverviewProps) {
  const { t } = useTranslation();

  const startAt = new Date(shift.startAt).toLocaleString("nl-NL", {
    hour: "2-digit",
    minute: "2-digit",
  });
  const endAt = new Date(shift.endAt).toLocaleString("nl-NL", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <IonItem
      className="ion-no-padding w-full rounded-2xl bg-surface-primary text-md [--border-width:0] [--detail-icon-color:var(--ion-color-brand)] [--detail-icon-opacity:1] [--inner-padding-end:16px] [--padding-end:0] [--padding-start:0]"
      lines="none"
      style={{ "--background": "var(--ion-color-surface-primary)" }}
      button={true}
      detail={false}
      routerLink={Routes.ProjectShifts(
        { id: shift.project?.id },
        { search: { fromUrl: Routes.UpcomingShifts() } },
      )}
    >
      <Card className="w-full overflow-hidden border-none bg-surface-primary shadow-none">
        <CardContent className="p-4">
          <div className="flex flex-col gap-2">
            <div className="flex items-start justify-between">
              <h3 className="truncate pr-2 font-bold capitalize text-txt-primary">
                {shift.project?.name}
              </h3>
              <IonIcon icon={hourglassIcon} className="size-5 flex-shrink-0 text-brand-500" />
            </div>
            <div className="flex items-center gap-1">
              <p className="truncate capitalize text-txt-primary">
                {new Date(shift.startAt).toLocaleDateString("nl-NL", {
                  weekday: "short",
                  day: "numeric",
                  month: "long",
                })}
              </p>
              {shift.userFunction?.name && (
                <>
                  •<p className="truncate text-brand-500">{shift.userFunction?.name}</p>
                </>
              )}
            </div>
            <ShiftApplicationDetails
              label={t("entity:position.singular.capitalized")}
              labelValue={shift.position?.name}
              startTime={startAt}
              endTime={endAt}
            />
          </div>
        </CardContent>
      </Card>
    </IonItem>
  );
}
